import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'
import { capitalizeFirstLetter, formatRoleGroupLabel } from '@/utils/helper'
import { DayjsProperty } from '@/lib/jackson'
import { Dayjs } from 'dayjs'

@Serializable()
export class Province extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string
}

@Serializable()
export class District extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string

  @JsonProperty({
    path: 'province',
    type: Province,
  })
  province!: Province
}

@Serializable()
export class SubDistrict extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string

  @JsonProperty('zipCode')
  zipCode!: number

  @JsonProperty('districtId')
  districtId!: number
}

@Serializable()
export class Location extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string

  @JsonProperty('zipCode')
  zipCode!: number

  @JsonProperty({
    path: 'district',
    type: District,
  })
  district!: District
}

@Serializable()
export class RoleGroup extends Fromable {
  @JsonProperty('group')
  group!: string

  @JsonProperty('position')
  position!: string[]

  get positionOption() {
    return {
      label: formatRoleGroupLabel(this.group),
      value: this.group,
    }
  }

  get levelOption() {
    return this.position.map((pos) => ({
      label: capitalizeFirstLetter(pos),
      value: pos,
    }))
  }
}

@Serializable()
export class GroupService extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string
}

@Serializable()
export class TrainingService extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('groupId')
  groupId!: number

  @JsonProperty('nameTh')
  nameTh!: string

  @JsonProperty('nameEn')
  nameEn!: string

  @DayjsProperty()
  createdAt!: Dayjs

  @JsonProperty('description')
  description!: string

  @JsonProperty('serviceGroup')
  serviceGroup!: GroupService
}
